/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import ProfileModelPopup from "../../components/modelpopup/ProfileModelPopup";
import {
  Applogo,
  Avatar_02,
  Avatar_01,
  headerlogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";
import { FaRegBell, FaRegComment } from "react-icons/fa";
import { useGlobalData } from "./../context/GlobalDataContext";
import ProfileMenu from "./ProfileMenu"; // Import the ProfileMenu component

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const profilePic = localStorage.getItem('profilepic');
  const submitButtonRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const { employeeData, employeeLoading } = useGlobalData();
  const empcode = localStorage.getItem("empcode");

  const edata = employeeData.map((employee) => ({
    id: employee.id || "N/A",
    name: `${employee.name || "Unknown"} ${employee.lastname || ""}`.trim(),
    department: employee.department_name || "Not Specified",
    phone: employee.mobile || "N/A",
    extension: employee.work_phone || "-",
    profile_pic: employee.profile_pic,
    gender: employee.gender,
    attendance_status: employee.attendance_status,
    leave_status: employee.leave_status,
  }));

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (value) {
      const filtered = edata.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest('.search-input') &&
        !event.target.closest('.suggestions-container')
      ) {
        setIsFocused(false);
        setSuggestions([]);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleAppClick = (app) => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
    switch (app) {
      case 'office':
        navigate('./employee-dashboard');
        break;
      case 'hms':
        navigate('/hospitality');
        break;
      case 'pos':
        alert('NetShine POS is available but not added to your plan. Please upgrade your plan.');
        break;
      default:
        break;
    }
  };

  const handleLogout = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
    localStorage.clear();
    sessionStorage.clear();
    navigate(baseUrl);
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };

  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = localStorage.getItem("username");
  const useremail = localStorage.getItem("useremail");
  const gender = localStorage.getItem("gender");

  const handleAccountClick = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
    setTimeout(() => {
      navigate("/account-setting");
    }, 300);
  };

  const handleApiClick = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
    setTimeout(() => {
      navigate("/api-settings");
    }, 300);
  };

  const handleManageOrgClick = () => {
    if (submitButtonRef.current) {
      submitButtonRef.current.click();
    }
    setTimeout(() => {
      navigate("/company-settings");
    }, 300);
  };

  const { t } = { t: (key) => key }; // Fallback translation function

  return (
    <div className="header" style={{ right: "0px" }}>
      <div className="header-left">
        <Link to="/" className="logo">
          <img src={headerlogo} width={150} height={50} alt="img" />
        </Link>
        <Link to="/" className="logo2">
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div>
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link>
      <div
        className="header-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
          height: "100%",
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <form
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              className="form-control search-input"
              type="text"
              placeholder="Search.."
              onFocus={() => setIsFocused(true)}
              onBlur={() => {
                if (!suggestions.length) setIsFocused(false);
                setTimeout(() => setSuggestions([]), 150);
              }}
              onChange={handleInputChange}
              style={{
                width: isFocused ? "100%" : "70%",
                height: "40px",
                padding: "0 40px 0 10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                background: "rgb(170, 172, 179)",
                transition: "width 0.3s ease-in-out",
              }}
            />
            <button
              className="btn"
              type="submit"
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
              }}
            >
              {isFocused ? (
                <i
                  className="fa fa-search"
                  style={{
                    position: "absolute",
                    left: "-0px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "18px",
                    color: "#555",
                    display: isFocused ? "block" : "none",
                  }}
                />
              ) : (
                <i
                  className="fa fa-search"
                  style={{
                    position: "absolute",
                    right: "176px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "18px",
                    color: "#555",
                    display: isFocused ? "none" : "block",
                  }}
                />
              )}
            </button>
          </form>
          {suggestions.length > 0 && (
            <div
              className="suggestions-container"
              style={{
                position: "absolute",
                top: "100%",
                left: "0",
                width: "100%",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                zIndex: "1000",
                overflow: "hidden",
              }}
            >
              {suggestions.map((item) => (
                <div
                  key={item.id}
                  className="suggestion-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    borderBottom: "1px solid #ddd",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSearchText(item.name);
                    setSuggestions([]);
                  }}
                >
                  <div className="profile-img" style={{ width: "40px", height: "40px" }}>
                    <Link to={`/profile/${item.id}`}>
                      <img
                        src={
                          item.profile_pic
                            ? `${cdnUrl}/${item.profile_pic}`
                            : item.gender === "male"
                            ? Avatar_01
                            : Avatar_02
                        }
                        alt="Employee Avatar"
                      />
                    </Link>
                  </div>
                  <div style={{ flex: 1 }}>
                    <Link to={`/profile/${item.id}`}>
                      <strong>{item.name}</strong>
                    </Link>
                    <span
                      style={{
                        color:
                          item.leave_status !== null
                            ? "green"
                            : item.attendance_status === "Not Checked In"
                            ? "red"
                            : item.attendance_status === "Checked In"
                            ? "green"
                            : "yellow",
                        fontWeight: "bold",
                        marginLeft: "8px",
                        fontSize: "12px",
                      }}
                    >
                      {item.leave_status !== null
                        ? "On Leave"
                        : item.attendance_status === "Not Checked In"
                        ? "OUT"
                        : item.attendance_status === "Checked In"
                        ? "IN"
                        : "N/A"}
                    </span>
                    <div style={{ fontSize: "12px", color: "#555" }}>
                      {item.department}
                    </div>
                  </div>
                  <div style={{ textAlign: "right", fontSize: "12px" }}>
                    <div>
                      <i className="fa fa-phone" style={{ marginRight: "5px" }} />
                      {item.phone}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div
          className="profile-section"
          style={{
            textAlign: "right",
            marginLeft: "10px", // Minimal spacing after search bar
          }}
        >
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="modal"
              data-bs-target="#profile-menu"
              onClick={handleProfile}
            >
              <span className="user-img me-1">
                <div className="profile-image">
                  <img
                    src={
                      profilePic && profilePic.trim() !== "" && profilePic !== "null"
                        ? `${cdnUrl}/${profilePic}`
                        : gender === "male"
                        ? Avatar_01
                        : Avatar_02
                    }
                    alt="User Avatar"
                    className="user-avatar"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </span>
            </Link>
          </li>
        </div>
      </div>
      <ProfileMenu
        profilePic={profilePic}
        gender={gender}
        ProfileName={ProfileName}
        useremail={useremail}
        empcode={empcode}
        flagImage={flagImage}
        handleLogout={handleLogout}
        handleAccountClick={handleAccountClick}
        handleApiClick={handleApiClick}
        handleManageOrgClick={handleManageOrgClick}
        handleAppClick={handleAppClick}
        locationLabel="Current Location" // Pass custom location label
        showCompanySettings={true} // Enable Company Settings link
      />
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link className="dropdown-item" to="/profile">
            My Profile
          </Link>
          <Link className="dropdown-item" to="/settings/companysetting">
            Settings
          </Link>
          <Link className="dropdown-item" to="#" onClick={handleLogout}>
            Logout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;